import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssistedSchedulerComponent } from './assisted-scheduler.component';
import { MaterialModule } from 'app/core/material_modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import { HlmButtonModule } from '@spartan-ng/ui-button-helm';
import { HlmMenuBarModule, HlmMenuComponent, HlmMenuGroupComponent, HlmMenuItemDirective, HlmMenuItemModule, HlmMenuModule } from '@spartan-ng/ui-menu-helm';
import { HlmIconComponent } from '@spartan-ng/ui-icon-helm';
import { BrnSelectModule } from '@spartan-ng/ui-select-brain';
import { HlmSelectModule } from '@spartan-ng/ui-select-helm';
import { HlmCheckboxCheckIconComponent, HlmCheckboxComponent } from '@spartan-ng/ui-checkbox-helm';



@NgModule({
  declarations: [
    AssistedSchedulerComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMatTimepickerModule,
    BrnMenuTriggerDirective,
    HlmButtonModule,
    HlmMenuComponent,
    HlmMenuItemDirective,
    HlmMenuGroupComponent,
    HlmIconComponent,
    HlmMenuModule,
    BrnSelectModule,
    HlmSelectModule,
    HlmCheckboxCheckIconComponent,
    HlmCheckboxComponent,
    HlmMenuItemModule,
    HlmMenuBarModule,
  ]
})
export class AssistedSchedulerModule { }
